import React from 'react';
import Calculator from '../components/Calculator';

function CalculatorPage() {
  return (
    <div className="calculator-page">
      <h2>Let&apos;s do some math.</h2>
      <Calculator />
    </div>
  );
}

export default CalculatorPage;
